(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dp-entry-boost"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dp-entry-boost')) {
    class DpEntryBoost extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.frame = this.querySelector('[data-boost-frame]');
        this.launcher = this.querySelector('[data-boost-launcher]');
        this.details = this.querySelector('[data-boost-details]');
        this.summary = this.details.querySelector('summary');
        this.multiplier = Number(this.dataset.multiplier);
        this.storageKey = `dp-entry-boost:${this.multiplier}`;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.numberFormat = new Intl.NumberFormat(this.dataset.locale);
        this.moneyFormat = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 });
        const options = { signal: this.controller.signal };
        const minimize = this.querySelector('[data-boost-minimize]');
        minimize.hidden = false;
        this.querySelectorAll('[data-boost-amount]').forEach(button => {
          button.textContent = this.moneyFormat.format(Number(button.dataset.boostAmount));
          button.addEventListener('click', () => this.updateExample(Number(button.dataset.boostAmount)), options);
        });
        this.updateExample(50);
        let minimized = false;
        try { minimized = sessionStorage.getItem(this.storageKey) === 'minimized'; } catch {}
        this.setMinimized(minimized && this.dataset.designMode !== 'true', false);
        minimize.addEventListener('click', () => this.animateChange(() => {
          this.setMinimized(true);
          this.launcher.focus({ preventScroll: true });
        }), options);
        this.launcher.addEventListener('click', () => this.animateChange(() => {
          this.setMinimized(false);
          this.details.open = true;
          this.summary.focus({ preventScroll: true });
        }), options);
        this.summary.addEventListener('click', event => {
          event.preventDefault();
          this.animateChange(() => { this.details.open = !this.details.open; });
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !this.details.open) return;
          const ownsFocus = this.contains(document.activeElement);
          this.animateChange(() => {
            this.details.open = false;
            if (ownsFocus) this.summary.focus({ preventScroll: true });
          });
        }, options);
        document.addEventListener('focusin', event => {
          if (this.contains(event.target)) {
            delete this.dataset.focusOccluded;
            return;
          }
          this.details.open = false;
          if (!(event.target instanceof HTMLElement)) return;
          const target = event.target.getBoundingClientRect();
          const widget = (this.frame.hidden ? this.launcher : this.frame).getBoundingClientRect();
          const overlaps = target.width > 0 && target.height > 0 && target.left < widget.right && target.right > widget.left && target.top < widget.bottom && target.bottom > widget.top;
          this.dataset.focusOccluded = String(overlaps);
        }, options);
      }
      updateExample(amount) {
        this.querySelectorAll('[data-boost-amount]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.boostAmount) === amount)));
        this.querySelector('[data-boost-result]').textContent = this.numberFormat.format(amount * this.multiplier);
      }
      setMinimized(minimized, persist = true) {
        this.frame.hidden = minimized;
        this.launcher.hidden = !minimized;
        this.details.open = false;
        delete this.dataset.focusOccluded;
        if (persist) {
          try { sessionStorage.setItem(this.storageKey, minimized ? 'minimized' : 'visible'); } catch {}
        }
      }
      animateChange(update) {
        if (!document.startViewTransition || this.motionQuery.matches || this.transitionRunning || document.querySelectorAll('dp-entry-boost').length !== 1) {
          update();
          return;
        }
        this.transitionRunning = true;
        document.documentElement.classList.add('dp-boost-transition');
        const transition = document.startViewTransition(update);
        transition.finished.catch(() => {}).finally(() => {
          document.documentElement.classList.remove('dp-boost-transition');
          this.transitionRunning = false;
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    }
    customElements.define('dp-entry-boost', DpEntryBoost);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dp-macbook-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dp-macbook-countdown')) {
    customElements.define('dp-macbook-countdown', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.endAt);
        this.timer = null;
        this.ended = false;
        this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-time-unit="${unit}"]`));
        this.onVisibility = () => {
          clearTimeout(this.timer);
          if (!document.hidden) this.tick();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.hero = this.closest('.dp-campaign-banner--countdown');
        if (this.hero && typeof ResizeObserver !== 'undefined') {
          this.sizeObserver = new ResizeObserver(() => this.hero.style.setProperty('--dp-countdown-half', `${this.getBoundingClientRect().height / 2}px`));
          this.sizeObserver.observe(this);
        }
        this.formatDeadline();
        this.tick();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.sizeObserver?.disconnect();
      }
      formatDeadline() {
        if (!Number.isFinite(this.deadline)) return;
        try {
          const date = new Date(this.deadline);
          const locale = this.dataset.locale.startsWith('en') ? 'en-CA' : 'fr-CA';
          const day = new Intl.DateTimeFormat(locale, { timeZone: 'America/Toronto', day: 'numeric', month: 'short', year: 'numeric' }).format(date);
          const time = new Intl.DateTimeFormat(locale, { timeZone: 'America/Toronto', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).format(date);
          this.querySelector('[data-deadline]').textContent = `${day} · ${time}`;
        } catch {}
      }
      tick() {
        clearTimeout(this.timer);
        const remaining = Number.isFinite(this.deadline) ? Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000)) : 0;
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        this.units.forEach((element, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (element.textContent !== value) element.textContent = value;
        });
        if (remaining === 0) {
          if (!this.ended) {
            this.ended = true;
            this.dataset.ended = 'true';
            this.querySelectorAll('[data-promo-active]').forEach(element => { element.hidden = true; });
            this.querySelectorAll('[data-promo-ended]').forEach(element => { element.hidden = false; });
            this.querySelector('[data-expiry-status]').textContent = this.dataset.expiredMessage;
          }
          return;
        }
        if (!document.hidden) this.timer = setTimeout(() => this.tick(), 1000 - Date.now() % 1000 + 20);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
